/**
 * 달을 옮기는 산수 — `Date.setMonth` 가 **달을 건너뛰기** 때문에 따로 둔다.
 *
 * ⛔ **실측(2026-09-28)**: 월간에서 10월을 보다 「다음 달」을 누르면 **11월이 아니라 12월**이
 *   열렸다. `cursor` 가 10/31 이었고 `setMonth(10)` 이 「11월 31일」을 만들자 JS 가 12/1 로
 *   넘긴 것이다. 월간 화면은 그리는 범위를 1일로 보정해 주기 때문에 «cursor 의 일»이
 *   31 이라는 사실이 평소에는 안 보이고, 달을 옮기는 순간에만 터진다.
 *   (cursor 가 31일이 되는 길 — 일간에서 31일을 보다 월간으로 오면 그 값이 따라온다.)
 */

/** 그 달의 마지막 날짜(1~31). */
export function lastDayOfMonth(year: number, monthIndex: number): number {
  // 다음 달의 «0일» = 이 달의 마지막 날. 윤년 2월도 이 한 줄이 맞춘다.
  return new Date(year, monthIndex + 1, 0).getDate();
}

/**
 * 달만 delta 만큼 옮긴다 — **일은 1일로 두고** 옮기므로 건너뛰지 않는다.
 * 월간 `cursor` 의 뜻이 「그 달의 월초」라 이것이 그 뜻과도 맞는다.
 */
export function stepMonth(cursor: Date, delta: number): Date {
  const d = new Date(cursor);
  d.setDate(1);                                   // ★ setMonth «앞»이어야 한다
  d.setMonth(cursor.getMonth() + delta);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * 「같은 날짜」를 다른 달로 옮긴다 — 9/15 → 10/15.
 * ⛔ 그 달에 그 «일»이 없으면 **마지막 날로 자른다** — 1/31 → 2/28 (윤년이면 2/29).
 *   자르지 않으면 JS 가 3/3 으로 넘겨, 레일이 «보고 있는 달 밖»을 가리킨다.
 *
 * 사용자 결정(2026-09-28): 달을 옮길 때 레일은 「새 달의 같은 날짜」를 가리킨다.
 */
export function sameDayInMonth(day: Date, targetMonth: Date): Date {
  const y = targetMonth.getFullYear();
  const m = targetMonth.getMonth();
  const d = new Date(y, m, Math.min(day.getDate(), lastDayOfMonth(y, m)));
  d.setHours(0, 0, 0, 0);
  return d;
}

/** 며칠 옮긴다 — 주 이동(±7)과 일 이동(±1)이 같은 길을 쓴다. */
export function stepDays(date: Date, days: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  d.setHours(0, 0, 0, 0);
  return d;
}
